/**
 * Loading Spinner Component
 */
interface LoadingProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
}

export function Loading({ size = 'md', text }: LoadingProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  }

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div
        data-testid="loading-indicator"
        className={`${sizeClasses[size]} animate-spin rounded-full border-4 border-gray-200 border-t-primary-500`}
      />
      {text && <p className="mt-4 text-sm text-gray-500">{text}</p>}
    </div>
  )
}

/**
 * Full page loading
 */
export function PageLoading({ text = '加载中...' }: { text?: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loading size="lg" text={text} />
    </div>
  )
}

/**
 * Inline loading (for cards, tables, etc.)
 */
export function InlineLoading() {
  return <Loading size="sm" />
}
